export const SituacaoComposicaoCarga = Object.freeze({
  EmNegociacao: 1,
  Finalizado: 2,
  Cancelado: 3,
  Aceito: 4,
  AguardandoSAP: 5,
  AguardandoRevisaoFornecedor: 6,
  NegociacaoEmergencial: 7
})
